export default __webpack_public_path__ + "static/media/bgm.8eeecfae.mp3";